/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PriceJobMode {
    COMPANY_JOBS = 'companyJobs',
    COMPANY_JOBS_FAMILY = 'companyJobsFamily',
    COMPANY_JOBS_SUB_FAMILY = 'companyJobsSubFamily',
}
